<template>
<div class="banner">
    <div class="banner-content">
        <cube-slide class="banner-wrapper"
                    :data="site.images"
                    :interval="3000"
                    :speed="300"
                    :showDots="false"
                    ref="slide"
                    v-if="site.images && site.images.length > 0">
            <cube-slide-item v-for="(item, index) in site.images" :key="item.id">
                <img class="banner-img" v-lazy="generateObj(item.image)" @click="handlePreview(index)" />
            </cube-slide-item>
        </cube-slide>
        <img src="/image/default_img.jpg" class="banner-img" v-else/>
        <img v-if="siteId !== '129'"  class="banner-wave" src="@/assets/scenic/sentosa-wave-white.svg" />
    </div>
</div>
</template>

<script>
import { ImagePreview } from 'vant'
import 'vant/lib/image-preview/style'

export default {
    data () {
        return {
            siteId: '1'
        }
    },
    props: {
        site: {
            type: Object,
            deault: () => {
                return {}
            }
        }
    },
    watch: {
        site () {
            this.$refs.slide.refresh()
        }
    },
    methods: {
        generateObj (src) {
            return {
                src,
                error: '/image/default_img.jpg',
                loading: '/image/loading-img.jpg'
            }
        },
        handlePreview (index) {
            ImagePreview({
                images: this.site.images.map(item => item.image),
                startPosition: index,
                closeable: true,
                'close-icon-position': 'top-right'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  height: 165px;
  background-color: #ffffff;

    .banner-wave {
        position: absolute;
        width: 100%;
        height: 58px;
        bottom: 0;
        left: 0;
        z-index: 10;
    }
    .banner-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
}

.banner-img {
  width: 100%;
  height: 150px;
  display: block;
  object-fit: cover;
  background-color: #888888;
}
</style>